import combineReducers from 'redux/lib/combineReducers';

import report from './report';

export default combineReducers({
  report,
});
